import React, { useContext, useState, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import AppContext from "../../../state/AppContext";
import APIInvoke from '../../../utils/APIInvoke';
import { IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { DateTime } from 'luxon';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';


const HighFrequencyAlertsDashboard = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { appContext } = useContext(AppContext);
    const project = appContext.project
    
    const [alerts, setAlerts] = useState(undefined);
    const [counter, setCounter] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isRunning) return;
            fetchData();
        }, 10000);

        // Limpieza del intervalo cuando el componente se desmonte
        return () => clearInterval(interval);
    }, [isRunning]);

    useEffect(() => {
        if (loading) return;
        fetchData();
    }, [appContext.project]);

    const fetchData = async () => {
        try {
            if (!isRunning) {
                setLoading(true);
            }
            const response = await (await APIInvoke.invokeGET(`/projects/${appContext.project}/dashboard/high-frequency-alerts?timestamp[bw]=${DateTime.now().minus({ days: 1 }).toUTC().toISO()},${DateTime.now().toUTC().toISO()}&page=0&size=10&sort=timestamp,desc`)).json();
            setAlerts(response.body.items);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const onRowClick = (event, collection, documentId) => {
        navigate(`/projects/${project}/collections/${collection}/documents/${documentId}`, { state: { backLink: location.pathname } })
    }

    return (

        <div>
            <Paper className=" ">
                <div className="relative px-4 bg-gray-100 p-2 border-t border-gray-300 flex flex-row justify-between items-center">
                    <div className="flex flex-row items-center"><CrisisAlertIcon fontSize="medium" className="text-dark-500"/><span className="pl-2">Last High Frequency Alerts (24 hrs)</span></div>
                    <Tooltip title={isRunning ? "Stop" : "Start"} className="flex items-center">
                        <IconButton onClick={() => setIsRunning(!isRunning)}>
                            {isRunning
                                ? <StopCircleIcon className={isRunning ? "text-red-500 animate-pulse" : "text-red-500"} fontSize="medium" />
                                : <PlayCircleIcon className="text-green-500" fontSize="medium" />}
                        </IconButton>
                    </Tooltip>
                </div>
                <div className="p-2">
                    <TableContainer className="border">
                        <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"small"}  >
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" padding={'normal'} >
                                        <TableSortLabel >Collection</TableSortLabel>
                                    </TableCell>
                                    <TableCell align="left" padding={'normal'} > 
                                        <TableSortLabel >Document Key</TableSortLabel>
                                    </TableCell>
                                    <TableCell align="left" padding={'normal'} >
                                        <TableSortLabel >Count</TableSortLabel>
                                    </TableCell>
                                    <TableCell align="left" padding={'normal'} >
                                        <TableSortLabel >Timestamp</TableSortLabel>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {((alerts || []).length === 0) && (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">No alerts found</TableCell>
                                    </TableRow>
                                )}
                                {(alerts || []).map((row, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            onClick={(event) => onRowClick(event, row.collection, row.documentId)}
                                            tabIndex={-1}
                                            key={row.id}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <TableCell align="left">{row.collection}</TableCell>
                                            <TableCell align="left">{row.documentKey}</TableCell>
                                            <TableCell align="left">{row.count}</TableCell>
                                            <TableCell align="left">{DateTime.fromISO(row.timestamp).setZone('local').toLocaleString(DateTime.DATETIME_SHORT)}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Paper>
        </div>

    );
}
export default HighFrequencyAlertsDashboard;